module.exports = "<div class=\"tv_chart_container\" id=\"tv_chart_container\"></div>\r\n"